/**
 * Table type. Tables can be closure, junction,, etc.
 */
export type TableType = "regular"|"view"|"junction"|"closure"|"closure-junction"|"entity-child";
